exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.container-table[data-v-407ae9a2] {\n  margin-bottom: 20px;\n}\n.tables th[data-v-407ae9a2] {\n  border: none;\n}\n.button-page[data-v-407ae9a2] {\n  float: right;\n  margin-right: 0.5em;\n}\n.no-border[data-v-407ae9a2] {\n  border: hidden;\n  background: none;\n}\nth[data-v-407ae9a2] {\n  padding: 1em;\n}\ntd[data-v-407ae9a2] {\n  padding: 1em;\n}\n#take-call[data-v-407ae9a2] {\n  border: 1px solid #1c869a;\n  border-radius: 10px !important;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4), 0 1px 2px rgba(0, 0, 0, 0.24);\n  transition: 0.2s;\n}\n#take-call[data-v-407ae9a2]:hover {\n  background-color: #1c869a5c;\n}\n", ""]);

// exports
